(() => {
  const ready = new WeakSet();
  const init = () => document.querySelectorAll('cb-atelier').forEach(atelier => {
    if (ready.has(atelier)) return;
    const trigger = atelier.querySelector('[data-open-zoom]');
    const dialog = atelier.querySelector('[data-zoom-dialog]');
    if (!trigger || !dialog) return;
    ready.add(atelier);
    const viewport = dialog.querySelector('[data-zoom-viewport]');
    const canvas = dialog.querySelector('[data-zoom-canvas]');
    const output = dialog.querySelector('output');
    const minus = dialog.querySelector('[data-zoom-out]');
    const plus = dialog.querySelector('[data-zoom-in]');
    let scale = 1, fit = 0, overflow = '';
    const pointers = new Map();
    const setZoom = value => {
      const previous = scale;
      scale = Math.max(1, Math.min(3, value));
      const x = (viewport.scrollLeft + viewport.clientWidth / 2) / previous;
      const y = (viewport.scrollTop + viewport.clientHeight / 2) / previous;
      canvas.style.width = `${fit * scale}px`;
      viewport.scrollLeft = x * scale - viewport.clientWidth / 2;
      viewport.scrollTop = y * scale - viewport.clientHeight / 2;
      output.textContent = `${Math.round(scale * 100)}%`;
      minus.disabled = scale <= 1;
      plus.disabled = scale >= 3;
    };
    trigger.addEventListener('click', () => {
      const clone = atelier.querySelector('[data-preview-frame]').cloneNode(true);
      clone.removeAttribute('data-preview-frame');
      clone.querySelector('[data-open-zoom]')?.remove();
      canvas.replaceChildren(clone);
      dialog.querySelector('[data-zoom-selection]').textContent = [atelier.querySelector('[data-base-label]').textContent, atelier.querySelector('[data-shell-label]').textContent].join(' · ');
      overflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      dialog.showModal();
      fit = Math.max(1, Math.min(viewport.clientWidth - 24, (viewport.clientHeight - 24) * .75));
      scale = 1;
      setZoom(1);
      viewport.scrollTo(0, 0);
    });
    dialog.querySelector('[data-close-zoom]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => {
      document.body.style.overflow = overflow;
      pointers.clear();
      canvas.replaceChildren();
      trigger.focus({preventScroll:true});
    });
    minus.addEventListener('click', () => setZoom(scale - .5));
    plus.addEventListener('click', () => setZoom(scale + .5));
    canvas.addEventListener('dblclick', () => setZoom(scale > 1 ? 1 : 2));
    canvas.addEventListener('pointerdown', event => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      canvas.setPointerCapture(event.pointerId);
      pointers.set(event.pointerId, {x:event.clientX,y:event.clientY});
    });
    canvas.addEventListener('pointermove', event => {
      const old = pointers.get(event.pointerId);
      if (!old) return;
      const before = [...pointers.values()];
      pointers.set(event.pointerId, {x:event.clientX,y:event.clientY});
      if (pointers.size === 2) {
        const after = [...pointers.values()];
        const distance = points => Math.hypot(points[0].x-points[1].x,points[0].y-points[1].y);
        const prior = distance(before);
        if (prior > 0) setZoom(scale * distance(after) / prior);
      } else {
        viewport.scrollLeft -= event.clientX - old.x;
        viewport.scrollTop -= event.clientY - old.y;
      }
    });
    ['pointerup','pointercancel','lostpointercapture'].forEach(type => canvas.addEventListener(type, event => pointers.delete(event.pointerId)));
  });
  init();
  document.addEventListener('shopify:section:load', init);
})();
